export default __webpack_public_path__ + "static/media/logo-default.a9441b44.png";